import { apiPaths, queryKeyWithNpsn } from 'api/kinerja/kepala-sekolah/config'
import { useKinerjaApi } from 'api/kinerja/utils/api'

import type { KinerjaTipe, MultiPeriodParams } from 'types/kinerja'
import type {
  ResponseContentKinerjaByPsAndDinas,
  ResponseKinerjaKsByPs,
  ResponsePendingPerencanaanKsByPs,
} from 'types/kinerja-ks'
import type { UseQueryOptions } from 'react-query'

export const API_GET_KS_PERENCANAAN_BY_PS_QUERY_KEY =
  'API_GET_KS_PERENCANAAN_BY_PS_QUERY_KEY'

export const API_GET_KS_PENDING_PERENCANAAN_BY_PS_QUERY_KEY =
  'API_GET_KS_PENDING_PERENCANAAN_BY_PS_QUERY_KEY'

export const API_GET_KS_CONTENT_KINERJA_BY_PS_QUERY_KEY =
  'API_GET_KS_CONTENT_KINERJA_BY_PS_QUERY_KEY'

export function useApiGetPerencanaanPs(
  npsn: string,
  opts?: UseQueryOptions<ResponseKinerjaKsByPs>
) {
  return useKinerjaApi<ResponseKinerjaKsByPs>(
    apiPaths.perencanaanPengawasSekolah,
    {
      axiosConfig: {
        params: {
          npsn,
        },
      },
      queryConfig: {
        useErrorBoundary: false,
        ...opts,
      },
      queryKey: queryKeyWithNpsn(API_GET_KS_PERENCANAAN_BY_PS_QUERY_KEY, npsn),
    }
  )
}

export function useApiGetContentKinerjaPs({
  npsn,
  tipe,
  ...opts
}: UseQueryOptions<ResponseContentKinerjaByPsAndDinas> & {
  npsn: string
  tipe?: KinerjaTipe
  override?: MultiPeriodParams
}) {
  return useKinerjaApi<ResponseContentKinerjaByPsAndDinas>(
    `${apiPaths.kontenPengawasSekolah}/kinerja`,
    {
      axiosConfig: {
        params: {
          npsn,
          tipe,
          ...opts?.override,
        },
      },
      queryConfig: {
        useErrorBoundary: false,
        ...opts,
      },
      queryKey: queryKeyWithNpsn(
        API_GET_KS_CONTENT_KINERJA_BY_PS_QUERY_KEY,
        npsn
      ),
    }
  )
}

export function useApiGetPendingPerencanaan(
  { limit }: { limit?: number },
  opts?: UseQueryOptions<ResponsePendingPerencanaanKsByPs>
) {
  return useKinerjaApi<ResponsePendingPerencanaanKsByPs>(
    `${apiPaths.perencanaanPengawasSekolah}/pending`,
    {
      axiosConfig: {
        params: {
          limit,
        },
      },
      queryConfig: {
        useErrorBoundary: false,
        ...opts,
      },
      queryKey: [
        API_GET_KS_PENDING_PERENCANAAN_BY_PS_QUERY_KEY,
        ...(limit ? [limit] : []),
      ],
    }
  )
}
